"use strict";

exports.__esModule = true;
exports.global_breakpoint_lg = {
  "name": "--pf-global--breakpoint--lg",
  "value": "992px",
  "var": "var(--pf-global--breakpoint--lg)"
};
exports["default"] = exports.global_breakpoint_lg;